import styled from 'styled-components';

const Title = styled.h1`
  font-family: Poppins, sans-serif;
  margin: 1rem;
  font-size: 2rem;
  font-weight: 700;
  width: 50%;
`;

export default Title;
